import React from 'react';
import PopoutWindow from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/PopoutWindow";
import {useViewerStore} from "../../../../store/store";
import TotalSystemEfficiency from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/TotalSystemEfficiency";
import RoofInformationTable from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/RoofInformationTable";
import IrradienceCharts from '../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/IrradienceCharts';
import MonthlyProductionEstimate from '../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/MonthlyProductionEstimate';
import { Pane } from '../../../../@types/types';

const IrradiancePopup: React.FC = () => {
    const panes: Pane[] = [
        {
            tab: 'Total System Efficiency',
            key: 'totalSystemEfficiencyTab',
            content: <TotalSystemEfficiency popoutVersion={true}/>,
        },
        {
            tab: 'Roof Efficiency Table',
            key: 'roofEfficiencyTab',
            content: <RoofInformationTable />,
            onPaneChangeCallback: () => {
                useViewerStore.setState({pitchDisplayMode: "Pitch Override"});
            },
            onMinMaxPopoutCallback: () => {
                useViewerStore.setState({pitchDisplayMode: "Pitch Override"});
            }
        },
        {
            tab: 'Irradiance',
            key: 'irradianceTab',
            content: <IrradienceCharts/>,
        },
        {
            tab: 'Monthly Production Estimate',
            key: 'monthlyProductionEstimate',
            content: <MonthlyProductionEstimate />
        }
    ];

    return ( <PopoutWindow tooltip={"Show System Information"} panes={panes}/> );
}

export default IrradiancePopup;
